module.exports = __webpack_public_path__ + "static/media/11774842_969842336370522_965208301_n.d6303b37.jpg";